<template>
  <v-container>
      <v-layout row wrap>
          <v-flex xs12 >
              <v-card max-width="783px">
                  <v-card-title>
                      {{socials.name}}
                  </v-card-title>
                      <v-img :src="socials.profilePic" height="500px"></v-img>
                  <v-card-text>
                    {{socials.bio}}
                  </v-card-text>

                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn v-if="!friends(socials.id)" @click="sendRequest(socials.id)">
                          <v-icon left>mdi-plus</v-icon> Friend
                      </v-btn>

                      <v-btn router :to="'/messages/' + this.id">
                          <v-icon left  color="blue darken-2">mdi-message-text</v-icon> Message
                      </v-btn>
                  </v-card-actions>
              </v-card>


          </v-flex>
      </v-layout>
  </v-container>

</template>

<script>
export default {
    props:['id'],
    computed: {
      socials() {
        return this.$store.state.allUsers[this.id]
      },
      friend() {
        return this.$store.getters.friends
      }

    },
    methods: {
      newProfile(social) {
        return this.$store.state.allUsers[social].profilePic
      },
      sendRequest(social){
        this.$store.dispatch('firebaseAddFriend', social)
      },
      friends(social){
       return this.$store.state.friends[social]
      }
    },
  mounted() {
    this.$store.dispatch('firebaseGetFriends')
  }
}
</script>
